import { useState, useRef, useEffect, useCallback } from 'react';
import { useNodeStore } from '../stores/nodeStore';

export function useHistory() {
    const nodes = useNodeStore((s) => s.nodes);
    const connections = useNodeStore((s) => s.connections);
    const setNodes = useNodeStore((s) => s.setNodes);
    const setConnections = useNodeStore((s) => s.setConnections);
    const [history, setHistory] = useState<any[]>([]);
    const [historyIndex, setHistoryIndex] = useState(-1);
    const nodesRef = useRef(nodes);
    const connectionsRef = useRef(connections);
    const historyRef = useRef(history);
    const historyIndexRef = useRef(historyIndex);

    useEffect(() => {
        nodesRef.current = nodes;
        connectionsRef.current = connections;
        historyRef.current = history;
        historyIndexRef.current = historyIndex;
    }, [nodes, connections, history, historyIndex]);

    const saveHistory = useCallback(() => {
        try {
            const currentStep = {
                nodes: JSON.parse(JSON.stringify(nodesRef.current)),
                connections: JSON.parse(JSON.stringify(connectionsRef.current)),
            };
            const newHistory = historyRef.current.slice(0, historyIndexRef.current + 1);
            newHistory.push(currentStep);
            if (newHistory.length > 50) newHistory.shift();
            setHistory(newHistory);
            setHistoryIndex(newHistory.length - 1);
        } catch (e) {
            console.warn('History save failed:', e);
        }
    }, []);

    const undo = useCallback(() => {
        const idx = historyIndexRef.current;
        if (idx > 0) {
            const prev = historyRef.current[idx - 1];
            setNodes(prev.nodes);
            setConnections(prev.connections);
            setHistoryIndex(idx - 1);
        }
    }, [setNodes, setConnections]);

    return { saveHistory, undo, history, historyIndex };
}
